import axios from "axios"

// These are backend Routes that get proxied to port 5001
const API_GETWORKERTRANSACTIONS = '/api/worker/monthlyPunchData'   
const API_getAttendanceByJobsite = '/api/dash/jobsiteAttendance'  
const API_BackendTest = '/api/dash/test'      
// API Route for profile type: user

const API_getAttendanceByWorker = '/api/dash/workerAttendance'

// Get Worker's Transactions by workerId ID
const getMonthlyPunchData_Worker = async (month, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }

    // Send month as part of the request body
    const response = await axios.post(API_GETWORKERTRANSACTIONS, { month }, config)
    return response.data
}


const getJobsiteAttendance = async (payload, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    try {
        const response = await axios.post(API_getAttendanceByJobsite, payload, config);
        return response.data;
    } catch (error) {
        console.error("Error in getJobsiteAttendance: ", error.response ? error.response.data : error.message);
        throw error;
    }
}

// Get the attendance records for a worker by workerId
// Parameter payload may include workerID, dateOne, and dateTwo, which the backend will handle.
const getAttendanceByWorker = async (payload, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    try {
        // Send payload as part of the request body
        const response = await axios.post(API_getAttendanceByWorker, payload, config);
        console.log("Response from getAttendanceByWorker: ", response.data);
        return response.data;
    } catch (error) {
        console.error("Error in getAttendanceByWorker ", error.response ? error.response.data : error.message);
        throw error;
    }
}

const backendTest = async () => {
    try {
        const response = await axios.get(API_BackendTest)
        console.log("Response from backend test: ", response.data)
        return response.data
    } catch (error) {
        console.error("Error in backendTest: ", error.response ? error.response.data : error.message)
        throw error
    }
}

const workHistoryService = {
    getMonthlyPunchData_Worker,
    getJobsiteAttendance,
    backendTest,
    getAttendanceByWorker,
}

export default workHistoryService